var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M441.363 0H151.925c-15.265 0-27.683 12.418-27.683 27.683v12.931h-12.961c-15.265 0-27.683 12.418-27.683 27.683v12.93H70.645c-15.269 0-27.69 12.416-27.69 27.677v375.421c0 15.261 12.421 27.677 27.69 27.677h289.424c15.268 0 27.69-12.416 27.69-27.677v-12.937h12.961c15.265 0 27.683-12.418 27.683-27.683v-12.93h12.961c15.265 0 27.683-12.419 27.683-27.684V27.683C469.045 12.418 456.627 0 441.363 0zm-81.294 492H70.645c-4.24 0-7.69-3.443-7.69-7.677V108.902c0-4.233 3.45-7.677 7.69-7.677h223.717v63.341c0 5.522 4.478 10 10 10h63.397v309.757c-.001 4.234-3.45 7.677-7.69 7.677zm-6.466-337.434h-39.241v-39.212zm54.799 289.138a7.683 7.683 0 0 1-7.683 7.683h-12.961V164.616l-.008-.476a9.44 9.44 0 0 0-2.766-6.487l-.001-.001c-.052-.054-73.553-73.501-73.553-73.501l-.293-.276a9.824 9.824 0 0 0-6.773-2.65H103.598v-12.93a7.683 7.683 0 0 1 7.683-7.683h289.438a7.683 7.683 0 0 1 7.683 7.683zm40.643-40.613c0 4.236-3.446 7.684-7.683 7.684h-12.961V68.296c0-15.265-12.418-27.683-27.683-27.683H144.242v-12.93c0-4.236 3.447-7.683 7.683-7.683h289.437c4.236 0 7.683 3.446 7.683 7.683z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPages);
export default __webpack_public_path__ + "static/media/pages.4fe6979d3e8595de4e524babd075225e.svg";
export { ForwardRef as ReactComponent };